import React  from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import OpportunityBasicInfoComponent from './opportunity-basic-info.component';
import OpportunityActivityInfoComponent from './opportunity-activity-info.component';

export const OpportunityComponent = ({ 
  handleInnerFormChange, selectedOpportunity, accountNameList, leadSource, opportunityStage, tagNames,
  opportunityType, contactNameLists, campaigns, selectedOpportunityTaskActivity, selectedOpportunityCallLog,
  handleTaskActivityInnerFormChange, handleCallActivityInnerFormChange, back, handleFormSubmit, sourceType, leads, taskStatus
}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Opportunity Details',
        component:<OpportunityBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedOpportunity={selectedOpportunity}
        accountNameList={accountNameList}
        contactNameLists={contactNameLists}
        opportunityType={opportunityType}
        leadSource={leadSource}
        opportunityStage={opportunityStage}
        campaigns={campaigns}
        tagNames={tagNames}
       />,
    isVisible:true,
    },
    {
      id:2,
      title:'Activity Info',
      component:<OpportunityActivityInfoComponent 
      handleTaskActivityInnerFormChange={handleTaskActivityInnerFormChange}
      handleCallActivityInnerFormChange={handleCallActivityInnerFormChange}
      selectedOpportunityTaskActivity={selectedOpportunityTaskActivity}
      selectedOpportunityCallLog={selectedOpportunityCallLog}
      selectedOpportunity={selectedOpportunity}
      sourceType={sourceType}
      contactNameLists={contactNameLists}
      leads={leads}
      taskStatus={taskStatus}
    />,
    isVisible:true,
    },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default OpportunityComponent;
